import React from "react";
import Modal from "react-modal";
import { Button } from "@/components/ui/button";
import { AlertTriangle } from "lucide-react";

interface PurgeInvoicesModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isPurging: boolean;
}

const PurgeInvoicesModal: React.FC<PurgeInvoicesModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  isPurging,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      style={{
        content: {
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          borderRadius: "8px",
          padding: "24px",
          background: "white",
          boxShadow: "0 10px 25px rgba(0,0,0,.3)",
          width: "calc(100% - 32px)",
          maxWidth: "500px",
          minBlockSize: "fit-content",
          overflowY: "auto",
        },
        overlay: {
          backgroundColor: "rgba(0,0,0,0.3)",
          zIndex: 9999,
        },
      }}
    >
      <h3 className="text-xl font-semibold text-gray-900">
        Purge Imported Invoices
      </h3>

      <div className="py-4">
        <p className="text-gray-600 mb-4">
          Are you sure you want to purge all imported invoices.
        </p>

        <div className="p-4 bg-red-50 border border-red-300 rounded-lg">
          <div className="flex items-start">
            <AlertTriangle className="w-5 h-5 text-red-600 mr-3 mt-0.5" />
            <div className="text-sm text-red-800">
              <p className="font-semibold mb-2">Warning:</p>
              <ul className="space-y-1">
                <li>• This will permanently purge all imported invoice data</li>
                <li>• This action cannot be undone</li>
              </ul>
            </div>
          </div>
        </div>

        <p className="mt-4 text-sm text-gray-600">
          Are you sure you want to proceed?
        </p>
      </div>

      <div className="mt-6 flex justify-end space-x-3">
        <Button disabled={isPurging} onClick={onClose} variant="outline">
          Cancel
        </Button>

        <Button disabled={isPurging} onClick={onConfirm}>
          {isPurging ? "Purging..." : "Purge Invoices"}
        </Button>
      </div>
    </Modal>
  );
};

export default PurgeInvoicesModal;
